<template>
  <nav
    id="navid"
    class="navbar navbar-light navbar-expand-md  justify-content-md-center justify-content-start"
  >
    <a class="navbar-brand d-md-none d-inline " href="">
      <!-- <img id="logo" class="logo-mob" src="/img/logo.png" /> -->
      <b-img
        id="logo"
        src="../img/logo.png"
        fluid
        alt="Fluid image"
        class="logo-mob"
      ></b-img>
    </a>
    <button
      class="navbar-toggler ml-1"
      type="button"
      data-toggle="collapse"
      data-target="#collapsingNavbar2"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div
      class="navbar-collapse collapse justify-content-between align-items-center w-100"
      id="collapsingNavbar2"
    >
      <ul class="navbar-nav mx-auto text-md-center text-right">
        <li class="nav-item active " @click="nv($event)">
          <router-link :to="{ name: 'Home', path: '/' }"
            ><a class="nav-link"
              ><i class="fa fa-home pl-1"></i><span>الرئيسية</span></a
            ></router-link
          >
        </li>
        <li class="nav-item dropdown " @click="nv($event)">
          <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown"
            ><i class="fa fa-graduation-cap pl-1"></i><span>الطلاب</span></a
          >
          <div class="dropdown-menu animated flipInX faster-500ms">
            <router-link
              v-if="std"
              :to="{ name: 'students', path: '/students' }"
              ><a class="nav-link"
                ><i class="fa fa-graduation-cap pl-1"></i><span>الطلاب</span></a
              ></router-link
            >
          </div>
        </li>
        <li class="nav-item dropdown " @click="nv($event)">
          <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown"
            ><i class="fa fa-user-tie pl-1"></i><span>السائقين</span></a
          >
          <div class="dropdown-menu animated flipInX faster-500ms">
            <router-link v-if="driver" :to="{ name: 'emps', path: '/emps' }"
              ><a class="nav-link"
                ><i class="fa fa-user-tie pl-1"></i><span>السائقين</span></a
              ></router-link
            >
          </div>
        </li>

        <li class="nav-item dropdown" @click="nv($event)">
          <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown"
            ><i class="fa fa-bus pl-1"></i><span>الحافلات</span></a
          >
          <div class="dropdown-menu animated flipInX faster-500ms">
            <router-link v-if="bus" :to="{ name: 'buses', path: '/buses' }"
              ><a class="nav-link"
                ><i class="fa fa-bus pl-1"></i><span>الحافلات</span></a
              ></router-link
            >
            <router-link v-if="busM" :to="{ name: 'busMain', path: '/busMain' }"
              ><a class="nav-link"
                ><i class="fa fa-bus pl-1"></i><span>صيانة الحافلات</span></a
              ></router-link
            >
            <router-link
              v-if="busF"
              :to="{ name: 'followBus', path: '/followBus' }"
              ><a class="nav-link"
                ><i class="fa fa-bus pl-1"></i><span>تتبع الحافلات</span></a
              ></router-link
            >
          </div>
        </li>
        <li class="nav-item my-auto">
          <a class="nav-link navbar-brand mx-0 d-none d-md-inline" href="">
            <img id="logo" src="../img/logo.png" />
          </a>
        </li>
        <li id="seprate-logo" class="nav-item dropdown " @click="nv($event)">
          <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown"
            ><i class="fa fa-doller-sign pl-1"></i><span>الحسابات</span></a
          >
          <div class="dropdown-menu animated flipInX faster-500ms">
            <router-link v-if="income" :to="{ name: 'income', path: '/income' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i
                ><span>سندات القبض</span></a
              ></router-link
            >
            <router-link
              v-if="outcome"
              :to="{ name: 'outcome', path: '/outcome' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i
                ><span>سندات الصرف</span></a
              ></router-link
            >
          </div>
        </li>

        <li class="nav-item dropdown " @click="nv($event)">
          <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown"
            ><i class="fa fa-doller-sign pl-1"></i><span>التقارير</span></a
          >
          <div class="dropdown-menu animated flipInX faster-500ms">
            <router-link
              v-if="Report_subscribe"
              :to="{ name: 'allsubscripe', path: '/allsubscripe' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i
                ><span>مجموع الاشتراكات</span></a
              ></router-link
            >
            <router-link
              v-if="Report_driverAccounts"
              :to="{ name: 'driversAccounts', path: '/driversAccounts' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i
                ><span> حسابات السائقين</span></a
              ></router-link
            >
            <router-link
              v-if="Report_depitByBus"
              :to="{ name: 'depitByBus', path: '/depitByBus' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i
                ><span> المدينين بالحافلة</span></a
              ></router-link
            >
            <router-link
              v-if="Report_creditByBus"
              :to="{ name: 'creditByBus', path: '/creditByBus' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i
                ><span> المسددين بالحافلة</span></a
              ></router-link
            >
            <router-link
              v-if="Report_paymentsStd"
              :to="{ name: 'stdbill', path: '/stdbill' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i
                ><span> حساب طالبة </span></a
              ></router-link
            >
          </div>
        </li>
        <li class="nav-item dropdown " @click="nv($event)">
          <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown"
            ><i class="fa fa-doller-sign pl-1"></i><span>التحكم</span></a
          >
          <div class="dropdown-menu animated flipInX faster-500ms">
            <router-link
              v-if="classes_Main"
              :to="{ name: 'classesYears', path: '/classesYears' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i
                ><span>الفصول الدراسية</span></a
              ></router-link
            >
            <router-link
              v-if="cities_Main"
              :to="{ name: 'cities', path: '/cities' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i><span>المدن</span></a
              ></router-link
            >
            <router-link
              v-if="cities_Main"
              :to="{ name: 'branches', path: '/branches' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i><span>الفروع</span></a
              ></router-link
            >
            <router-link
              v-if="district_Main"
              :to="{ name: 'districts', path: '/districts' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i><span>الاحياء</span></a
              ></router-link
            >
            <router-link
              v-if="college_Main"
              :to="{ name: 'colleges', path: '/colleges' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i><span>الجامعات</span></a
              ></router-link
            >
            <router-link
              v-if="user_Main"
              :to="{ name: 'users', path: '/users' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i
                ><span>المستخدمين</span></a
              ></router-link
            >
            <router-link
              v-if="user_Main"
              :to="{ name: 'roles', path: '/roles' }"
              ><a class="nav-link"
                ><i class="fa fa-doller-sign pl-1"></i><span>الصلاحيات</span></a
              ></router-link
            >
          </div>
        </li>
        <router-link class="nav-item" to="/"
          ><a class="nav-link"
            ><i class="fa fa-share-square pl-1"></i><span>خروج</span></a
          ></router-link
        >
        <!-- <li class="nav-item"   @click="logout">
          <a class="nav-link" to="/"
            ><i class="fa fa-share-square pl-1"></i><span>خروج</span></a
          >
        </li> -->
      </ul>
    </div>
  </nav>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "navbar",
  data() {
    return {
      std: false,
      driver: false,
      bus: false,
      busM: false,
      busF: false,
      income: false,
      outcome: false,
      Report_subscribe: false,
      Report_driverAccounts: false,
      Report_depitByBus: false,
      Report_creditByBus: false,
      Report_paymentsStd: false,
      classes_Main: false,
      cities_Main: false,
      district_Main: false,
      college_Main: false,
      user_Main: false,
    };
  },
  computed: {
    ...mapGetters({
      check: "GET_ROLES",
    })
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.busy = true;
      var fd = this.check;
      if (fd) {
        this.Role_check();
      } else {
        //  await  this.$store.actions('login',logn);
        await this.$store
          .dispatch("stdMod/loadnav")
          .then((res) => {
            if (res.data.status == "success") {
              this.Role_check();
            }
          })
          .catch((err) => {
            console.log(err);
          });

        setTimeout(() => {
          this.submitStatus = "دخول";
        }, 500);
      }
    },
    nv(e) {
      var elements = document
        .getElementById("navid")
        .getElementsByClassName("active");
      while (elements.length > 0) {
        elements[0].classList.remove("active");
      }
      var el = e.target.closest(".nav-item");
      el.classList.add("active");
    },
    async logout() {
      await this.$store
        .dispatch("logoutAction")
        .then((res) => {
          if (res.data.status == "success") {
            this.$router.push("/");
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    Role_check() {
      this.std = this.check.std_Main == 1 ? true : false;
      this.driver = this.check.driver_Main == 1 ? true : false;
      this.bus = this.check.bus_Main == 1 ? true : false;
      this.busM = this.check.busM_Main == 1 ? true : false;
      this.busF = this.check.busF_Main == 1 ? true : false;
      this.income = this.check.income_Main == 1 ? true : false;
      this.outcome = this.check.outcome_Main == 1 ? true : false;
      this.Report_subscribe = this.check.Report_subscribe == 1 ? true : false;
      this.Report_driverAccounts =
        this.check.Report_driverAccounts == 1 ? true : false;
      this.Report_depitByBus = this.check.Report_depitByBus == 1 ? true : false;
      this.Report_creditByBus =
        this.check.Report_creditByBus == 1 ? true : false;
      this.Report_paymentsStd =
        this.check.Report_paymentsStd == 1 ? true : false;
      this.classes_Main = this.check.classes_Main == 1 ? true : false;
      this.cities_Main = this.check.cities_Main == 1 ? true : false;
      this.district_Main = this.check.district_Main == 1 ? true : false;
      this.college_Main = this.check.college_Main == 1 ? true : false;
      this.user_Main = this.check.user_Main == 1 ? true : false;
    },
  },
};
</script>
<style scoped>
.navbar {
  margin-bottom: 20px;
}
</style>
